import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { ChannelName } from "../../channels/types";
import {
  type RecipientPerson,
  SupabaseRecipientService,
} from "../server/supabase-recipient-service";

export const useRecipientsForChannel = (
  channel: ChannelName,
  targetChannel: boolean,
): UseSupabaseLoaderState<RecipientPerson[]> => {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      if (channel === null || channel === "personal_email") {
        return [];
      }

      const { data, error } = await new SupabaseRecipientService(supabase).getForChannel(
        account_id,
        channel,
        targetChannel,
      );

      if (error) throw error;

      return data;
    },
    [channel, targetChannel],
  );
};
